<template>
  <div>
    <el-input v-model="value1" type="number" style="width:45%;" @input="onInputOne" :size="size" placeholder=""></el-input>
    -
    <el-input v-model="value2" type="number" style="width:46%;" @input="InputTwo" :size="size" placeholder=""></el-input>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value1: '',
      value2: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.value1 = val.split('-')[0]
        this.value2 = val.split('-')[1]
      }
    }
  },
  methods: {
    onInputOne(val) {
      let res = ''
      if (this.value1 && !this.value2) {
        res = `${this.value1}-${this.value1}`
      }
      if (!this.value1 && this.value2) {
        res = `${this.value2}-${this.value2}`
      }
      if (!this.value1 && !this.value2) {
        res = ''
      }
      if (this.value1 && this.value2) {
        res = `${this.value1}-${this.value2}`
      }
      this.$emit('input', res)
      this.$emit('change', res)
    },
    InputTwo(val) {
      let res = ''
      if (this.value1 && !this.value2) {
        res = `${this.value1}-${this.value1}`
      }
      if (!this.value1 && this.value2) {
        res = `${this.value2}-${this.value2}`
      }
      if (!this.value1 && !this.value2) {
        res = ''
      }
      if (this.value1 && this.value2) {
        res = `${this.value1}-${this.value2}`
      }
      this.$emit('input', res)
      this.$emit('change', res)
    },
    clear() {
      this.value1 = ''
      this.value2 = ''
    }
  }
}
</script>
